(function () {
  var toastElement = null;
  var toastTimeout = null;
  var toastMotionMs = 450;
  var toastVisibleMs = 3200;

  function parseI18n() {
    var node = document.querySelector('[data-stock-alert-i18n]');
    if (!node) {
      return {};
    }
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function capitalizeToast(message) {
    var text = String(message || '').trim();
    if (!text) {
      return '';
    }
    return text.replace(/(^|\.\s+)([a-zçğıöşü])/g, function (match, prefix, letter) {
      return prefix + letter.toLocaleUpperCase('tr-TR');
    });
  }

  function ensureToastElement() {
    if (toastElement) {
      return toastElement;
    }
    toastElement = document.createElement('div');
    toastElement.className = 'favorites-toast';
    toastElement.setAttribute('role', 'status');
    toastElement.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastElement);
    return toastElement;
  }

  function revealToast(text) {
    var node = ensureToastElement();
    node.textContent = text;
    node.classList.remove('is-visible');
    void node.offsetWidth;
    window.requestAnimationFrame(function () {
      node.classList.add('is-visible');
    });
  }

  function showToast(message) {
    var text = capitalizeToast(String(message || '').trim());
    if (!text) {
      return;
    }
    if (toastTimeout) {
      window.clearTimeout(toastTimeout);
      toastTimeout = null;
    }
    var node = ensureToastElement();
    var wasVisible = node.classList.contains('is-visible');
    function scheduleHide() {
      toastTimeout = window.setTimeout(function () {
        node.classList.remove('is-visible');
        toastTimeout = null;
      }, toastVisibleMs);
    }
    if (wasVisible) {
      node.classList.remove('is-visible');
      window.setTimeout(function () {
        revealToast(text);
        scheduleHide();
      }, toastMotionMs);
      return;
    }
    revealToast(text);
    scheduleHide();
  }

  function getBoot() {
    return document.querySelector('[data-stock-alert-boot]');
  }

  function getConfig() {
    var boot = getBoot();
    if (!boot) {
      return null;
    }
    var datasetShop = boot.dataset.stockAlertShop || '';
    var shop =
      typeof window.jokerStorefrontShop === 'function'
        ? window.jokerStorefrontShop(datasetShop)
        : datasetShop;
    return {
      apiBase: String(boot.dataset.stockAlertApi || '').replace(/\/$/, ''),
      shop: shop,
      customerId: String(boot.dataset.stockAlertCustomerId || '').trim(),
      customerEmail: String(boot.dataset.stockAlertCustomerEmail || '').trim(),
      customerName: String(boot.dataset.stockAlertCustomerName || '').trim(),
    };
  }

  function setTriggerLabel(trigger, text) {
    var labelEl = trigger.querySelector('[data-buy-button-label]');
    if (labelEl) {
      labelEl.textContent = text;
      return;
    }
    trigger.textContent = text;
  }

  function subscribeStockAlert(trigger, config, i18n) {
    if (!config.customerId || !config.customerEmail) {
      showToast(i18n.login || '');
      return;
    }
    if (!config.apiBase || !config.shop) {
      return;
    }
    var form = trigger.closest('[data-product-buy]');
    var addLabel =
      trigger.dataset.labelAdd ||
      (form && form.dataset.stockAlertText) ||
      trigger.textContent ||
      '';
    var addingLabel =
      trigger.dataset.labelAdding || (form && form.dataset.stockAlertAddingText) || addLabel;
    trigger.disabled = true;
    setTriggerLabel(trigger, addingLabel);
    trigger.setAttribute('aria-busy', 'true');
    var payload = {
      shop: config.shop,
      customerId: config.customerId,
      customerEmail: config.customerEmail,
      productGid: trigger.dataset.productGid || (form && form.dataset.productGid) || '',
      productHandle: trigger.dataset.productHandle || (form && form.dataset.productHandle) || '',
      productTitle: trigger.dataset.productTitle || (form && form.dataset.productTitle) || '',
      variantGid: trigger.dataset.variantGid || '',
      variantTitle: trigger.dataset.variantTitle || '',
      productImageUrl:
        trigger.dataset.productImageUrl || (form && form.dataset.productImageUrl) || '',
      productUrl: trigger.dataset.productUrl || (form && form.dataset.productUrl) || '',
    };
    if (config.customerName) {
      payload.customerName = config.customerName;
    }
    var url =
      config.apiBase +
      '/api/storefront/stock-alerts?shop=' +
      encodeURIComponent(config.shop);
    fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json().then(function (body) {
          return { response: response, body: body };
        });
      })
      .then(function (result) {
        if (!result.response.ok || !result.body || !result.body.ok) {
          var message =
            result.body && result.body.error ? String(result.body.error) : i18n.error || '';
          throw new Error(message);
        }
        if (result.body.created) {
          showToast(i18n.success || '');
        } else {
          showToast(i18n.success_updated || i18n.success || '');
        }
      })
      .catch(function (error) {
        showToast(error && error.message ? error.message : i18n.error || '');
      })
      .then(function () {
        trigger.disabled = false;
        setTriggerLabel(trigger, addLabel);
        trigger.removeAttribute('aria-busy');
      });
  }

  function init() {
    var config = getConfig();
    if (!config || !config.apiBase) {
      return;
    }
    var i18n = parseI18n();
    if (document.documentElement.dataset.stockAlertClickBound === 'true') {
      return;
    }
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-stock-alert-trigger]');
      if (!trigger) {
        return;
      }
      event.preventDefault();
      subscribeStockAlert(trigger, config, i18n);
    });
    document.documentElement.dataset.stockAlertClickBound = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
